// test2797
(2797 && 0);
